module.exports = __webpack_public_path__ + "static/media/22.0a9c08ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/22.jpg
// module id = 481
// module chunks = 0